import { FlexColumn, Tooltip } from '@ubeya/shared-web/components';
import styled from 'styled-components';
import React, { useContext } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import moment from 'moment';
import { ago } from '@ubeya/shared/utils/time';

const Wrapper = styled(FlexColumn)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 5px;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const EmployeeSignoffRenderer = ({ rowData: { employeeApproved } }) => {
  const { dateFormat, timeFormat } = useContext(ConfigContext);
  const { t } = useContext(ConfigContext);

  if (!employeeApproved || !employeeApproved?.signature) {
    return <></>;
  }

  const { createdAt } = employeeApproved;

  const timeAgo = createdAt
    ? `${ago(createdAt, t)} (${moment(createdAt).format(dateFormat)} ${moment(createdAt).format(timeFormat)})`
    : '';

  const tooltip = `${t('employeeApprovedTimesheet')}, ${timeAgo}`;

  return (
    <Wrapper>
      <Tooltip body={tooltip}>
        <Image src={employeeApproved?.signature} />
      </Tooltip>
    </Wrapper>
  );
};

export default EmployeeSignoffRenderer;
